module.exports = __webpack_public_path__ + "media/video_smartphone_2_de.532b734d.mp4";